import kepler from "./kepler";

export default (name: string) => {
  switch (name) {
    case 'vehicle':
      return {
        id: 'hidden',
        plate: 'string',
        category: {
          id: fillSelect("select/vehicle_categories")
        },
        model: 'string',
        fuel_type: [{value: 0, text: 'PETROL'},{value: 1, text: 'DIESEL'},{value: 2, text: 'HYBRID'},
          {value: 3, text: 'GAS'},{value: 4, text: 'ELECTRIC'},{value: 5, text: 'HYDROGEN'},{value: 6, text: 'NONE'},{value: 7, text: 'OTHER'}],
        odometer: 'number',
        brand: {
          id: fillSelect("select/vehicle_brands"),
        },
        color: 'string',
        picture: 'picture',
        position: 'latlng'
      }
    case 'parking_lot':
      return {
        parking_group_id: 'hidden',
        id: 'hidden',
        name: 'string', //{type: 'text', label: "Name", rules: [ (v :any)=> !!v || 'Name is required',]},
        description: 'editor',
        picture: 'picture',
        allowed_zone: {
          id: fillSelect("zones"),
          name: 'hidden',
          uid: 'hidden'
        },
        undesiderable_zone: {
          id: fillSelect("zones")
        },
        forbidden_zone: {
          id: fillSelect("zones")
        },
        position: 'latlng'
        //latitude:  //{type:'number', label: "Latitude", rules: [ (v :any)=> !!v || 'Latitude is required',]},
        //longitude: //{type:'number', label: "Longitude", rules: [ (v :any)=> !!v || 'Longitude is required',]},
      }
    case 'vehicle_type':
      return {
        id: 'hidden',
        name: 'string',
        description: 'string'
      }
    case 'vehicle_category':
      return {
        id: 'hidden',
        name: 'string',
        vehicle_type: {
          id: fillSelect("vehicle_types"),
        },
        description: 'string',
        picture: 'picture',
        damage_picture: 'picture',
      }
    case 'note':
      return {
        id: 'hidden',
        valid_from: 'date',
        valid_to: 'date',
        description: 'string',
      }
    case 'vehicle_attribute':
      return {
        id: 'hidden',
        name: "string",
        description: 'string',
        type: [{value: 0, text: 'number'}, {value: 1, text: 'string'}],
        vehicle_type: {
          id: fillSelect("vehicle_types"),
        },
        recommended: "checkbox",
        private: "checkbox",
      }
    case 'zones':
      return {
        id: 'hidden',
        name: 'string',
        poly: 'poly',

      }
    case 'reportings':
      return {
        id: 'hidden',
        driver: {
          id: fillSelect('select/drivers', 'id', 'id+name+surname')
        },
        vehicle: {
          id: fillSelect('select/vehicles', 'id', 'id+brand+model')
        },
        type: {
          id: fillSelect('select/reporting_types')
        },
        status: // {
          //id: [{val: 'ALL_STATUS', text : 'All Statuses'},{val: 'PENDING_REVIEW', text : 'Pending Review'},{val: 'CONFIRMED', text : 'confirmed'},{val:'RESOLVED', text : 'resolved'},{val: 'VOIDED', text : 'voided'}]
        //}
          ['ALL_STATUS', 'PENDING_REVIEW', 'CONFIRMED', 'RESOLVED', 'VOIDED']
        ,
        description: 'editor',

      }
    case 'asset_cost_record':
      return {
        id: 'hidden',
        asset_cost_record_type: {
          id: fillSelect('asset_costs/types')
        },
        description: 'editor',
        amount:'number',
        tax:'number',
        date: 'date'
      }
    default:
      alert("SCHEMA " + name + " NOT FOUND")
  }

}

/**
 * This function will fetch the entities via the magic helper, and return a val-text array to fill the select
 */

let selectCache: any = []

function fillSelect(what: string, value: string = 'id', text: string = 'name'): { val: string, text: string }[] {
  if (selectCache[what]) {
    return selectCache[what]
  }

  let bag: { val: string, text: string }[] = []
  kepler.get(what)!.then(d => {

    d.data.forEach((item: any) => {
// When we need multiple items in a select row
      let textLabel =  ''
      text.split('+').forEach((x:string) => {
        if(x){
          textLabel += item[x] + ' '
        }

      })
      bag.push({val: item[value], text: textLabel})
    })
  })
  selectCache[what] = bag
  return bag
}

/*
{
  name*: {
    schema: {},
    transforms: {}
  },
  ....
  * es. parking_lot,notes ... come adesso
}
 */